import React, { useEffect, useState } from 'react';
import shuffle from 'lodash/shuffle';
import { Spinner } from '@vtblife/uikit';
import { getQuizProps } from '../../utils/get-quiz-props';
import { QuizModalLayout } from '../quiz-modal/components/quiz-modal-layout/quiz-modal-layout';
import { QuizModal } from '../quiz-modal/quiz-modal';
const quizCache = {};
export const Quiz = (props) => {
    const [isOpenLoader, setIsOpenLoader] = useState(false);
    const [quizProps, setQuizProps] = useState(null);
    const { id, background = 'transparent', layout = '8c', isOpen, onClose, environment = 'production' } = props;
    useEffect(() => {
        if (!id)
            return;
        if (quizCache[id]) {
            setQuizProps(quizCache[id]);
            return;
        }
        setIsOpenLoader(true);
        const fetchQuizProps = async () => {
            var _a;
            try {
                const data = await getQuizProps({ id, environment });
                // Перемешивание вариантов ответа
                (_a = data.steps) === null || _a === void 0 ? void 0 : _a.forEach((step) => {
                    var _a;
                    if ((_a = step.field) === null || _a === void 0 ? void 0 : _a.shuffleOptions) {
                        step.field.options = shuffle(step.field.options);
                    }
                });
                quizCache[id] = data;
                setQuizProps(data);
            }
            catch (error) {
                console.error(`Ошибка при загрузке пропсов квиза с id ${id}:`, error);
            }
            finally {
                setIsOpenLoader(false);
            }
        };
        fetchQuizProps();
    }, [id, environment]);
    if (isOpenLoader) {
        return (React.createElement(QuizModalLayout, { background: background, layout: layout, onClose: onClose, open: isOpen },
            React.createElement("div", { style: {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    height: '100%',
                } },
                React.createElement(Spinner, null))));
    }
    return quizProps ? React.createElement(QuizModal, { isOpen: isOpen, onClose: onClose, settings: quizProps }) : null;
};
//# sourceMappingURL=quiz.js.map